import {useState} from 'react';

import {
    safelyGetGraphQLErrorMessage,
    DEFAULT_GRAPHQL_ERROR_MESSAGE,
} from 'nutshell-core/utils/graphql-errors';

import {WidgetErrorBanner} from 'shells/card/card-widget/widget-error-banner';
import {EditableTextfieldContent} from 'shells/editable-textfield-content/editable-textfield-content';
import {PencilOutlineIcon} from 'shells/icon/svg/pencil-outline-icon';
import {BaseRow} from 'shells/row/base-row/base-row';
import {useManageSaveState} from 'shells/saved-setting-toast/use-manage-save-state';

interface Props {
    value: string | undefined;
    onUpdate: (newValue: string | null) => Promise<any>;
}

export function LegacyIdRow(props: Props) {
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {toastState, saveFailed} = useManageSaveState(isSaving, 1000);

    function handleUpdate(newValue?: string | null) {
        setIsSaving(true);
        setError(null);
        props
            .onUpdate(newValue || null)
            .then(() => setIsEditing(false))
            .catch((e) => {
                setError(safelyGetGraphQLErrorMessage(e) ?? DEFAULT_GRAPHQL_ERROR_MESSAGE);
                setIsEditing(false);
                saveFailed();
            })
            .finally(() => setIsSaving(false));
    }

    return (
        <>
            {error && (
                <div className='pb-2'>
                    <WidgetErrorBanner error={error} setError={(e) => setError(e ?? null)} />
                </div>
            )}
            <BaseRow
                type='custom-field-text'
                title='Legacy ID'
                saveToastState={toastState}
                toolbarProps={{
                    options: [
                        {
                            id: 'edit',
                            tooltipText: 'Edit Legacy ID',
                            onClick: () => setIsEditing(true),
                            icon: PencilOutlineIcon,
                        },
                    ],
                    forceHideToolbar: isEditing,
                }}
                onClick={() => setIsEditing(true)}
            >
                <EditableTextfieldContent
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    value={props.value ?? null}
                    onUpdate={handleUpdate}
                    placeholder='Add Legacy ID…'
                    isMultiline={false}
                />
            </BaseRow>
        </>
    );
}
